import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { TOTAL_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ProductIncomeYearFieldsForm from './ProductIncomeYearFieldsForm';

const ProductIncomeTotalForm = () => {
  const { productIncome } = useIncomeStructure();

  const totalProductIncome = findMasterDataById(
    productIncome,
    TOTAL_INCOME_STRUCTURE_ID.TOTAL_PRODUCT_INCOME
  );

  return (
    <>
      {totalProductIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }} required>
              {totalProductIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <ProductIncomeYearFieldsForm
            keyItem={totalProductIncome.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ProductIncomeTotalForm;
